import { Col } from 'reactstrap';
import { shallowEqual, useDispatch, useSelector } from 'react-redux';
import { actions } from '../../../../../context';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faClock } from '@fortawesome/free-solid-svg-icons';
import hasPermission from '../../../../Shared/hasPermission';
import {
    utcToPracticeTime,
    timeZoneAbbr,
} from '../../../../Shared/PracticeTimeZone';

const AttachmentExtractionScheduling = () => {
    const dispatch = useDispatch();
    const { windowStart, windowEnd, timeZone } = useSelector((state) => {
        const { attachmentSyncWindowStart, attachmentSyncWindowEnd, timeZone } =
            state.practice.practice;
        return {
            windowStart: attachmentSyncWindowStart,
            windowEnd: attachmentSyncWindowEnd,
            timeZone,
        };
    }, shallowEqual);

    const permissions = useSelector(
        (state) => state.auth.permissions,
        shallowEqual
    );
    const canSyncScheduling = hasPermission(`SyncScheduling`, permissions);

    if (!canSyncScheduling) return null;

    const openAttachmentScheduleModal = () => {
        dispatch(actions.toggle.toggleAttachmentScheduleModal(true));
    };

    // window is stored as UTC time-of-day; displayed in the practice's own time zone
    const toPracticeTime = (value) =>
        utcToPracticeTime(value, timeZone, 'h:mm a');
    const windowText =
        windowStart && windowEnd
            ? `${toPracticeTime(windowStart)} – ${toPracticeTime(windowEnd)} ${timeZoneAbbr(timeZone)}`
            : 'Not set';

    return (
        <Col
            md={12}
            title="Attachment Extraction Window"
            className="d-flex px-3 py-2 hover-parent hoverable"
            onClick={openAttachmentScheduleModal}>
            <span className="underline-on-hover">
                <FontAwesomeIcon
                    className="text-light op-6"
                    icon={faClock}
                    size="lg"
                />
                &emsp;
                <span className="hoverable config-item">
                    Attachments: {windowText}
                </span>
            </span>
        </Col>
    );
};

export default AttachmentExtractionScheduling;
